import React, { MouseEvent, FunctionComponent } from "react";
import { Partner } from "../../../api/Client";
import { getAddressFormat } from "../../../helpers/formatters";
import {Button, Card, Divider, TButtonSize} from "@velocity/ui";
import CustomButton from "../../ui/CustomButton";
import {localization} from "../../../localization/localizedStrings";
import {EyeopenIcon, LocationIcon, PhoneIcon} from "@velocity/icons/system";
import {openNavigate} from "../../../helpers/navigation";
import useStore from "../../../hooks-store/store";

export interface MapCardProps {
  data: Partner | null;
  width?: string;
  height?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  active?: boolean;
}

const MapCard: FunctionComponent<MapCardProps> = ({
  data,
  width,
  height,
  onClick,
  active,
}: MapCardProps) => {

    const [, setOpenDrawerStore] = useStore<boolean>(
        "openDrawer",
        false
    );
    const [partnerStore, setPartnerStore] = useStore<Partner | null>(
        "partner",
        null
    );

    const handleNavigate = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        openNavigate(partnerStore?.latitude ?? 0, partnerStore?.longitude ?? 0);
    };

    const handleOnMoreInfoClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setOpenDrawerStore(true);
        setPartnerStore(data);
    };

  return (
    <Card
      kind="elevated"
      id={data?.id?.toString()}
      style={{
        width: width,
        height: height,
        borderLeft: `6px solid ${data?.colorCode || "transparent"}`,

      }}
      className={`card-container ${
        active ? "active" : ""
      }`}
      onClick={onClick}
    >
      <Card.Body className="card-container-body">
        <div className="card-container-title">
          <strong>{data?.name}</strong>
        </div>
        <div>{getAddressFormat(data)}</div>


          {
              active && <div className={"card-container-detail"}>
                  <Divider/>
                  {
                      partnerStore?.gsm && (
                          <div style={{padding: "0.25rem"}}>
                              {localization.contactGsm}: &nbsp;
                              <strong>
                                  {partnerStore?.gsm
                                      ?.split(",")
                                      .map((gsm, idx) => {
                                          const trimmedGsm = gsm.trim();
                                          const hrefGsm = trimmedGsm.replace(/\s+/g, "");
                                          return trimmedGsm ? (
                                              <React.Fragment key={trimmedGsm + idx}>
                                                  <a style={{ color: 'white', textDecoration: 'none' }} href={`tel:${hrefGsm}`}>{trimmedGsm}</a>
                                                  {idx < partnerStore.gsm!.split(",").length - 1 && ", "}
                                              </React.Fragment>
                                          ) : null;
                                      })}
                              </strong>
                          </div>
                      )
                  }
                  {
                      partnerStore?.email && (
                          <div style={{padding: "0.25rem"}}>
                              {localization.contactEmail}:&nbsp;
                              <strong>
                                  {partnerStore?.email
                                      ?.split(",")
                                      .map((email, idx) => {
                                          const trimmedEmail = email.trim();
                                          return trimmedEmail ? (
                                              <React.Fragment key={trimmedEmail + idx}>
                                                  <a style={{ color: 'white', textDecoration: 'none' }} href={`mailto:${trimmedEmail}`}>{trimmedEmail}</a>
                                                  {idx < partnerStore?.email!.split(",").length - 1 && ", "}
                                              </React.Fragment>
                                          ) : null;
                                      })}
                              </strong>
                          </div>
                      )
                  }
                  {
                      partnerStore?.website && (
                          <div style={{padding: "0.25rem"}}>
                              {localization.websSite}:&nbsp;
                              <strong>
                                  <a style={{ color: 'white', textDecoration: 'none' }} href={`${partnerStore?.website}`} target="_blank">
                                      {partnerStore?.website}
                                  </a>
                              </strong>
                          </div>
                      )
                  }
                  {
                      partnerStore?.openingHours && (
                          <div style={{padding: "0.25rem"}}>
                              {localization.openingHours}:&nbsp;
                              <strong>{partnerStore?.openingHours}</strong>
                          </div>
                      )
                  }
                  <Divider/>
                  <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
                      <CustomButton
                          text={localization.navigate}
                          fullWidth
                          size={"s" as TButtonSize}
                          onClick={handleNavigate}
                          variant="primary-outlined"
                          startIcon={LocationIcon}
                      />
                      <Button
                          variant="primary-outlined"
                          fullWidth
                          size={"s" as TButtonSize}
                          onClick={(e: React.MouseEvent) => handleOnMoreInfoClick(e)}
                          StartIcon={EyeopenIcon}
                      >
                          {localization.moreInformations}
                      </Button>
                  </div>

                  <Button
                      style={{ marginTop: "0.5rem" }}
                      variant="primary-outlined"
                      fullWidth
                      size={"s" as TButtonSize}
                      onClick={() => {
                          window.location.href = "tel:+420955525000";
                      }}
                      StartIcon={PhoneIcon}
                  >
                      {localization.callToService}
                  </Button>
              </div>
          }
      </Card.Body>
    </Card>
  );
};

export default MapCard;
